const strictRange = /\[(.*),(.*)\]/
const halfopenRightRange = /\[(.*),(.*)\)/
const halfopenLeftRange = /\((.*),(.*)\]/
const qualifiers = ['M', 'RC', 'BUILD-SNAPSHOT', 'RELEASE']

export const parseQualifier = version => {
  const qual = (version || '')
    .replace(/\d+/g, '')
    .replace(/\./g, ' ')
    .replace(/\s/g, '')
  return qualifiers.indexOf(qual) > -1 ? qual : 'RELEASE'
}

export const parseVersion = version => {
  const r = version.toString().split('.')
  if (r.length < 2) {
    return {
      version,
    }
  }
  return {
    version,
    short: `${r[0]}.${r[1]}.${r[2]}`,
    major: `${r[0]}.${r[1]}.x`,
    qualify: qualifiers.indexOf(parseQualifier(version)),
    minor: +r[2],
  }
}

export const compare = (a, b) => {
  let prefixA = a.match(/^[A-z]+/)
  if (prefixA) {
    a = a.substring(prefixA[0].length)
  }
  let prefixB = b.match(/^[A-z]+/)
  if (prefixB) {
    b = b.substring(prefixB[0].length)
  }
  let result
  const versionA = a.split('.')
  const versionB = b.split('.')
  const len = Math.min(versionA.length, versionB.length, 3)
  for (let i = 0; i < len; i += 1) {
    const numA = parseInt(versionA[i], 10)
    const numB = parseInt(versionB[i], 10)
    
    // Steeltoe: Treat non-numeric parts as wildcards that match any number.
    if (isNaN(numA) || isNaN(numB)) {
      continue
    }
    
    result = numA - numB
    if (result !== 0) {
      return result
    }
  }
  if (Math.max(versionA.length, versionB.length) <= 3) {
    return 0
  }

  if (versionA.length === 3) {
    versionA[3] = ''
  }
  if (versionB.length === 3) {
    versionB[3] = ''
  }
  const qualify = version => qualifiers.indexOf(parseQualifier(version))
  result = qualify(a) - qualify(b)
  if (result !== 0) {
    return result
  }
  return versionA[3].localeCompare(versionB[3])
}

export const parseReleases = releases => {
  return releases.map(release => {
    const version = parseVersion(release.key)
    return version
  })
}

export const isInRange = (version, range) => {
  if (!range) {
    return true
  }
  const strickMatch = range.match(strictRange)
  if (strickMatch) {
    return (
      compare(strickMatch[1], version) <= 0 &&
      compare(strickMatch[2], version) >= 0
    )
  }
  const horMatch = range.match(halfopenRightRange)
  if (horMatch) {
    return (
      compare(horMatch[1], version) <= 0 && compare(horMatch[2], version) > 0
    )
  }
  const holMatch = range.match(halfopenLeftRange)
  if (holMatch) {
    return (
      compare(holMatch[1], version) < 0 && compare(holMatch[2], version) >= 0
    )
  }
  return compare(range, version) <= 0
}

export const rangeToText = range => {
  const strictMatch = range.match(strictRange)
  if (strictMatch) {
    return `>= ${strictMatch[1]} and <= ${strictMatch[2]}`
  }
  const horMatch = range.match(halfopenRightRange)
  if (horMatch) {
    return `>= ${horMatch[1]} and < ${horMatch[2]}`
  }
  const holMatch = range.match(halfopenLeftRange)
  if (holMatch) {
    return `> ${holMatch[1]} and <= ${holMatch[2]}`
  }
  return `>= ${range}`
}

export const getValidDependencies = (steeltoeVersion, dependencies) => {
  return dependencies
    .map(dep => {
      const compatibility = dep.steeltoeVersionRange
        ? isInRange(steeltoeVersion, dep.steeltoeVersionRange)
        : true
      if (!compatibility) {
        return null
      }
      return dep
    })
    .filter(d => !!d)
}
